/* eslint-disable react/prefer-es6-class, react/sort-comp, no-shadow, react/jsx-no-bind, react/prop-types */
import classnames from 'classnames';
import React from 'react';

/**
 * Keep a reference to the DOM element and word choice being dragged.
 */
let draggedElement = null;
let wordChoice = null;

export const WordPiece = React.createClass({
  displayName: 'WordPiece',

  propTypes: {
    className: React.PropTypes.string,
    enableDragEvents: React.PropTypes.bool,
    onClick: React.PropTypes.func,
    onDrag: React.PropTypes.func,
    onDragEnd: React.PropTypes.func,
    wordChoice: React.PropTypes.object,
  },

  getDefaultProps() {
    return {
      className: '',
      enableDragEvents: false,
      wordChoice: null,
    };
  },

  statics: {
    /**
     * Returns the current dragged element.
     *
     * @returns {HTMLElement}
     */
    getDraggedElement() {
      return draggedElement;
    },

    /**
     * Retu
     *
     * @returns {WordChoice}
     */
    getWordChoice() {
      return wordChoice;
    },
  },

  // This is to prevent selection in IE9, trigger the drag event instead.
  componentDidMount() {
    this.refs.wordPiece.addEventListener('selectstart', this._handleSelectStart);
  },

  componentWillUnmount() {
    this.refs.wordPiece.removeEventListener('selectstart', this._handleSelectStart);
  },

  _handleSelectStart(e) {
    e.preventDefault();
    e.stopPropagation();

    if (e.target.dragDrop) {
      e.target.dragDrop();
    }
  },

  /**
   * Set the global drag variables (since the event only allows for meta data).
   *
   * @param {DragEvent} e
   */
  _handleDragStart(e) {
    draggedElement = this.refs.wordPiece;
    wordChoice = this.props.wordChoice;

    // NOTE: Without specifying data to transfer, Firefox will not
    // perform the drag event. Use the static variables to get the
    // word choice or dragged element, instead.
    e.dataTransfer.setData('text', JSON.stringify(wordChoice));
  },

  _handleDrag(e) {
    if (this.props.onDrag) {
      this.props.onDrag.call(this, this.props.wordChoice, e);
    }
  },

  /**
   * Erase the global variables.
   *
   * @param {DragEvent} e
   */
  _handleDragEnd(e) {
    draggedElement = null;
    wordChoice = null;

    if (this.props.onDragEnd) {
      this.props.onDragEnd.call(this, this.props.wordChoice, e);
    }
  },

  render() {
    const className = classnames('word-piece', this.props.className);
    const wordChoice = this.props.wordChoice;
    const onClick = this.props.onClick && wordChoice ? this.props.onClick.bind(null, wordChoice) : null;

    const attributes = { className, onClick };

    if (this.props.enableDragEvents) {
      Object.assign(attributes, {
        draggable: true,
        onDragStart: this._handleDragStart,
        onDrag: this._handleDrag,
        onDragEnd: this._handleDragEnd,
      });
    }

    return (
      <span ref="wordPiece" {...attributes}>{this.props.children}</span>
    );
  },
});

export default WordPiece;
